<template>
    <modal @click="close">
        <div @click.stop class="content article">
            <h2>slideshow.builders</h2>
            <p>
                It's a tool helping with automatic generation of PowerPoint presentations using AI.
            </p>
            <p>
                Just describe topic, maybe add some more details in description, say how long it should be (number of
                slides) and how you - author- should be signed.
            </p>
            <h3>Credit points</h3>
            <p>Each account get 10 free credit points. Each generated presentations is one point. To get more points
                contact sales at contact@green-code.studio or call +48 783 769 544.</p>
            <h3>Support</h3>
            <p>
                You can write to contact@green-code.studio or call +48 783 769 544
            </p>
            <h3>Company data</h3>
            <p>Mateusz Krawczyk GCS<br>
                Oleska 264<br>
                42-161 Starokrzepice<br>
                Poland<br>
                VAT PL5741970332
            </p>
        </div>
    </modal>
</template>

<script>
export default {
    methods:{
        close() {
            this.$emit('close');
        }
    }
}
</script>
<style>

</style>
